import { titlePageInitialLabel } from '@/constants'
import { hasCrumb } from '@/routes/utils'
import { TypedMatch } from '@/types'
import { useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet'

const DocumentHead = (props: { title?: string; matches?: TypedMatch<void>[] }) => {
  const { matches, title } = props
  const resolvedTitle = useMemo(() => {
    if (title) return title

    const crumbs =
      matches
        ?.filter((element) => hasCrumb(element))
        .map((match) => {
          try {
            return match.handle.crumb(match).label
          } catch {
            // La crumb può lanciare quando il loader della route è andato in errore (es. 404):
            // match.data è undefined. La saltiamo per non far crashare il calcolo del titolo.
            return null
          }
        })
        .filter((label): label is string => label !== null) ?? []

    return crumbs.join(' - ')
  }, [matches, title])

  const fullTitle = useMemo(
    // eslint-disable-next-line sonarjs/no-nested-template-literals
    () => `${titlePageInitialLabel}${resolvedTitle ? ` - ${resolvedTitle}` : ''}`,
    [resolvedTitle],
  )

  useEffect(() => {
    document.title = fullTitle
  }, [fullTitle])

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>
    </>
  )
}

export default DocumentHead
